import { render } from "./FooterCucumber.vue?vue&type=template&id=b8da4e70"
import script from "./FooterCucumber.vue?vue&type=script&lang=js"
export * from "./FooterCucumber.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__